module.exports = __webpack_public_path__ + "img/BlockInternetPolicy_VI.c1f655a1.png";